import gsap from 'gsap'
import { createTextSprite } from './InteractionTile.js'

export default class BinView
{
    constructor(_options)
    {
        this.bin = _options.bin
        this.factory = _options.factory
        this.container = this.factory.createBin()
        this.container.position.set(this.bin.x, this.bin.y, 0)
        this.container.visible = this.bin.revealed
        this.lastStackKey = ''

        const label = createTextSprite('STORAGE BIN')
        label.position.set(0, 0, 2.25)
        label.scale.set(2.6, 0.54, 1)
        this.container.add(label)
        this.pin = this.factory.createPin()
        this.pin.position.z = 3.4
        this.pin.visible = false
        this.container.add(this.pin)
        this.sync()
    }

    reveal()
    {
        this.container.visible = true
        this.container.scale.setScalar(0.01)
        gsap.to(this.container.scale, { x: 1, y: 1, z: 1, duration: 0.65, ease: 'back.out(1.7)' })
        this.pin.visible = true
        gsap.to(this.pin.scale, {
            x: 0,
            y: 0,
            z: 0,
            delay: 4.5,
            duration: 0.5,
            onComplete: () => this.pin.visible = false
        })
    }

    update(_elapsed)
    {
        if(this.pin.visible)
        {
            this.pin.position.z = 3.4 + Math.sin(_elapsed * 0.007) * 0.35
            const haloScale = 1 + Math.sin(_elapsed * 0.009) * 0.18
            this.pin.userData.halo.scale.setScalar(haloScale)
        }
    }

    sync()
    {
        const key = JSON.stringify(this.bin.stored)
        if(key === this.lastStackKey)
            return
        this.lastStackKey = key

        const contents = this.container.userData.contents
        for(const child of [...contents.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            contents.remove(child)
        }

        const items = Object.entries(this.bin.stored)
            .flatMap(([_resource, _count]) => Array.from({ length: _count }, () => _resource))
            .slice(0, 27)
        items.forEach((_resource, _index) =>
        {
            const item = this.factory.createItem(_resource, 0.9)
            item.position.set((_index % 3 - 1) * 0.46, (Math.floor(_index / 3) % 3 - 1) * 0.4, Math.floor(_index / 9) * 0.28)
            item.rotation.z = (_index % 3 - 1) * 0.12
            contents.add(item)
        })
    }
}
